// Property Types
export const propertyTypes = [
    { label: 'Apartment', value: 'Apartment' },
    { label: 'Villa', value: 'Villa' },
    { label: 'Suite', value: 'Suite' },
    { label: 'Penthouse', value: 'Penthouse' },
    { label: 'Townhouse', value: 'Townhouse' },
    { label: 'Bunglow', value: 'Bunglow' },
    { label: 'Compound', value: 'Compound' }
] as const;

export type PropertyType = typeof propertyTypes[number]['value'];

// Property category
export const propertyCategories = [
    { label: 'Residential', value: 'RESIDENTIAL' },
    { label: 'Commercial', value: 'COMMERCIAL' }
] as const;

export type PropertyCategory = typeof propertyCategories[number]['value'];

// Property listing types
export const listingTypes = [
    { label: 'For Sale', value: 'SALE' },
    { label: 'For Rent', value: 'RENT' }
] as const;

export type ListingType = typeof listingTypes[number]['value'];

// Property status
export const propertyStatuses = [
    { label: 'Available', value: 'AVAILABLE' },
    { label: 'Not-Available', value: 'NOT-AVAILABLE' },
    { label: 'Off-Plan', value: 'OFF-PLAN' }
] as const;

export type PropertyStatus = typeof propertyStatuses[number]['value'];

// Admin Property Statuses
export const adminPropertyStatuses = [
    { label: 'Published', value: 'PUBLISHED' },
    { label: 'Pending', value: 'PENDING' },
    { label: 'Rejected', value: 'REJECTED' },
] as const;

export type AdminPropertyStatus = typeof adminPropertyStatuses[number]['value'];

// Property amenities
export const amenities = [
    { label: 'Swimming Pool', value: 'Swimming Pool' },
    { label: 'Infinity Pool', value: 'Infinity Pool' },
    { label: 'Splash Pad', value: 'Splash Pad' },
    { label: 'Pool Deck', value: 'Pool Deck' },
    { label: 'Jacuzzi', value: 'Jacuzzi' },
    { label: 'Foot Bath', value: 'Foot Bath' },
    { label: 'Aquatic Gym', value: 'Aquatic Gym' },
    { label: 'Indoor Gym', value: 'Indoor Gym' },
    { label: 'Security', value: 'Security' },
    { label: 'Garden', value: 'Garden' },
    { label: 'BBQ Area', value: 'BBQ Area' },
    { label: 'Reflexology Path & Aroma Garden', value: 'Reflexology Path & Aroma Garden' },
    { label: 'Outdoor Party Hall', value: 'Outdoor Party Hall' },
    { label: 'Jogger Arena', value: 'Jogger Arena' },
    { label: 'Cricket Pitch', value: 'Cricket Pitch' },
    { label: 'Badminton Court', value: 'Badminton Court' },
    { label: 'Mini Golf', value: 'Mini Golf' },
    { label: 'Elevator', value: 'Elevator' },
    { label: 'Sea/Water View', value: 'Sea/Water View' },
    { label: 'Library', value: 'Library' },
    { label: 'Open Air Cinema', value: 'Open Air Cinema' },
    { label: 'Concierge Service', value: 'Concierge Service' },
    { label: 'Beach Access', value: 'Beach Access' },
    { label: 'Fully Fitted Kitchen', value: 'Fully Fitted Kitchen' },
    { label: 'Sauna', value: 'Sauna' },
    { label: 'Prayer Room', value: 'Prayer Room' },
    { label: "Children's Pool", value: 'Children\'s Pool' },
    { label: 'Shallow Pool', value: 'Shallow Pool' },
    { label: 'Floating Cabana', value: 'Floating Cabana' },
    { label: 'Pool Party Area', value: 'Pool Party Area' },
    { label: 'Private Jacuzzi', value: 'Private Jacuzzi' },
    { label: 'Gym', value: 'Gym' },
    { label: 'Outdoor Gym', value: 'Outdoor Gym' },
    { label: 'Parking', value: 'Parking' },
    { label: 'Balcony', value: 'Balcony' },
    { label: "Children's Play Area", value: 'Children\'s Play Area' },
    { label: 'BBQ Garden', value: 'BBQ Garden' },
    { label: 'Indoor Party Hall', value: 'Indoor Party Hall' },
    { label: "Kid's Daycare", value: 'Kid\'s Daycare' },
    { label: 'Yoga Deck', value: 'Yoga Deck' },
    { label: 'Football Court', value: 'Football Court' },
    { label: 'Basketball Court', value: 'Basketball Court' },
    { label: 'Sparklz Garden', value: 'Sparklz Garden' },
    { label: 'Central AC', value: 'Central AC' },
    { label: 'Spa', value: 'Spa' },
    { label: 'Zumba Dance', value: 'Zumba Dance' },
    { label: 'Pet-Friendly', value: 'Pet-Friendly' },
    { label: 'Basement', value: 'Basement' },
    { label: 'View of Landmark', value: 'View of Landmark' },
    { label: 'Steam Room', value: 'Steam Room' },
    { label: 'Business Center', value: 'Business Center' },
    { label: 'Health Bar', value: 'Health Bar' }
] as const;

export type Amenity = typeof amenities[number]['value'];

// Localities
export const localities = [
    { label: 'Arjan', value: 'arjan' },
    { label: 'Business Bay', value: 'business-bay' },
    { label: 'Damac Hills', value: 'damac-hills' },
    { label: 'Downtown Dubai', value: 'downtown-dubai' },
    { label: 'Dubai Creek Harbour', value: 'dubai-creek-harbour' },
    { label: 'Dubai Hills Estate', value: 'dubai-hills-estate' },
    { label: 'Dubai Investment Park', value: 'dubai-investment-park' },
    { label: 'Dubai Marina', value: 'dubai-marina' },
    { label: 'Dubai Sports City', value: 'dubai-sports-city' },
    { label: 'Dubai South', value: 'dubai-south' },
    { label: 'Dubailand', value: 'dubailand' },
    { label: 'Dubai Science Park', value: 'dubai-science-park' },
    { label: 'Emirates Hills', value: 'emirates-hills' },
    { label: 'Jumeirah Beach Residence', value: 'jumeirah-beach-residence' },
    { label: 'Jumeirah Golf Estates', value: 'jumeirah-golf-estates' },
    { label: 'Jumeirah Lake Towers', value: 'jumeirah-lake-towers' },
    { label: 'Jumeirah Village Circle', value: 'jumeirah-village-circle' },
    { label: 'Majan', value: 'majan' },
    { label: 'Meydan', value: 'meydan' },
    { label: 'Mina Rashid', value: 'mina-rashid' },
    { label: 'Palm Jumeirah', value: 'palm-jumeirah' },
    { label: 'Wasl Gate', value: 'wasl-gate' },

] as const;

export type Locality = typeof localities[number]['value'];

// Developers
export const developers = [
    { label: 'Aldar', value: 'aldar' },
    { label: 'Azizi', value: 'azizi' },
    { label: 'Binghatti', value: 'binghatti' },
    { label: 'Damac', value: 'damac' },
    { label: 'Deniz', value: 'deniz' },
    { label: 'Danube', value: 'danube' },
    { label: 'Deyaar', value: 'deyaar' },
    { label: 'Dubai Properties', value: 'dubai-properties' },
    { label: 'Ellington', value: 'ellington' },
    { label: 'Emaar', value: 'emaar' },
    { label: 'Expo City', value: 'expo-city' },
    { label: 'Leos', value: 'leos' },
    { label: 'MAG', value: 'mag' },
    { label: 'Meraas', value: 'meraas' },
    { label: 'Nakheel', value: 'nakheel' },
    { label: 'Sobha Realty', value: 'sobha-realty' },
    { label: 'Vincitore', value: 'vincitore' },
    { label: 'Wasl', value: 'wasl' },

] as const;

export type Developer = typeof developers[number]['value'];

// Pricing Types
export const pricingTypes = [
    { label: 'Fixed', value: 'FIXED' },
    { label: 'Negotiable', value: 'NEGOTIABLE' }
] as const;

export type PricingType = typeof pricingTypes[number]['value'];

// Currencies
export const currencies = [
    { label: 'AED', value: 'AED' }
] as const;

export type Currency = typeof currencies[number]['value'];

// Bedrooms
export const bedrooms = [
    { label: 'Studio', value: 'studio' },
    { label: '1 Bed', value: '1' },
    { label: '2 Beds', value: '2' },
    { label: '3 Beds', value: '3' },
    { label: '4 Beds', value: '4' },
    { label: '5 Beds', value: '5' },
    { label: '6 Beds', value: '6' }
] as const;

export type Bedroom = typeof bedrooms[number]['value'];

// Bathrooms
export const bathrooms = [
    { label: '1 Bathroom', value: '1' },
    { label: '2 Bathrooms', value: '2' },
    { label: '3 Bathrooms', value: '3' },
    { label: '4 Bathrooms', value: '4' },
    { label: '5 Bathrooms', value: '5' },
    { label: '6 Bathrooms', value: '6' }
] as const;

export type Bathroom = typeof bathrooms[number]['value'];

// Furnishing Types
export const furnishingTypes = [
    { label: 'Furnished', value: 'FURNISHED' },
    { label: 'Semi-Furnished', value: 'SEMI-FURNISHED' },
    { label: 'Full-Furnished', value: 'FULL-FURNISHED' },
    { label: 'Unfurnished', value: 'UNFURNISHED' }
] as const;

export type FurnishingType = typeof furnishingTypes[number]['value'];

// Property Flags (for admin filtering)
export const propertyFlags = [
    { label: 'Featured', value: 'featured' },
    { label: 'Trending', value: 'trending' }
] as const;

export type PropertyFlag = typeof propertyFlags[number]['value'];

// Blog Statuses
export const blogStatusOptions = [
    { label: 'Published', value: 'published' },
    { label: 'Draft', value: 'draft' },
] as const;

// Insights Statuses
export const insightsStatusOptions = [
    { label: 'Published', value: 'published' },
    { label: 'Draft', value: 'draft' },
] as const;

export type BlogStatus = typeof blogStatusOptions[number]['value'];

// Blog Categories
export const blogCategories = [
    { label: 'Investment', value: 'INVESTMENT' },
    { label: 'Market Trends', value: 'MARKET-TRENDS' },
    { label: 'Buying Guide', value: 'BUYING-GUIDE' },
    { label: 'Selling Tips', value: 'SELLING-TIPS' },
    { label: 'Property Management', value: 'PROPERTY-MANAGEMENT' },
    { label: 'Luxury Properties', value: 'LUXURY-PROPERTIES' },
    { label: 'Off-Plan Properties', value: 'OFF-PLAN-PROPERTIES' },
    { label: 'Neighborhoods', value: 'NEIGHBORHOODS' }
] as const;

export type BlogCategory = typeof blogCategories[number]['value'];

// Market Insights
export const marketInsights = [
    { label: 'Market Analysis', value: 'market-analysis' },
    { label: "Investment", value: "investment" },
    { label: "Trends", value: "trends" },
    { label: "Forecast", value: "forecast" },
    { label: "Rental", value: "rental" },
    { label: "Commercial", value: "commercial" },
] as const;

export type MarketInsight = typeof marketInsights[number]['value'];

export const pagination = {
    page: 1,
    limit: 10,
    recentLimit: 5,
    cardLimit: 3,
} as const;



// Country Codes
export const countryCodes = [
    { label: 'UAE +971', value: '+971' },
    { label: 'IND +91', value: '+91' },
    { label: 'USA +1', value: '+1' },
    { label: 'UK +44', value: '+44' },
] as const;

export type CountryCode = typeof countryCodes[number]['value'];
